import { useRef } from 'react';

export const useDebounce = (action: () => void, delay: number) => {
  const timeoutRef = useRef<number | null>(null);

  const debouncedAction = () => {
    if (timeoutRef.current) {
      window.clearTimeout(timeoutRef.current);
    }
    timeoutRef.current = window.setTimeout(() => {
      action();
    }, delay);
  };

  return debouncedAction;
};
